import { Loading3QuartersOutlined } from '@ant-design/icons';
import { SubmitButton } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { Alert, Spin } from 'antd';
import * as React from 'react';
import { ButtonRowCardFooter } from '../button/ButtonRowCardFooter';
import { VerticalSpace } from '../space/VerticalSpace';
import { ResponsiveCard, ResponsiveCardProps } from './ResponsiveCard';

export interface INetworkResponsiveCardProps extends ResponsiveCardProps {
  loading?: boolean;
  fetching?: boolean;
  error?: string | undefined;
  showFooterSubmitButton?: boolean;
}

/**
 * Versione della card responsive che mostra un indicatore di caricamento
 * quando `spinning` è `true`.
 */
export function NetworkResponsiveCard(props: INetworkResponsiveCardProps) {
  const {
    loading,
    fetching,
    error,
    children,
    showFooterSubmitButton,
    ...otherProps
  } = props;
  const { t } = useTranslation();

  return (
    <Spin
      style={{ maxHeight: '70vh' }}
      size="large"
      spinning={loading ?? fetching}
      indicator={<Loading3QuartersOutlined spin />}
    >
      <ResponsiveCard {...otherProps}>
        {error ? (
          <Alert
            message={t('card.network-responsive-card.error', 'Errore')}
            showIcon
            type="error"
            description={error}
          />
        ) : (
          children
        )}
        {showFooterSubmitButton && (
          <>
            <VerticalSpace />
            <ButtonRowCardFooter>
              <SubmitButton />
            </ButtonRowCardFooter>
          </>
        )}
      </ResponsiveCard>
    </Spin>
  );
}
